import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5538c2c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid-table-body" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GridRow = _resolveComponent("GridRow")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (item, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: item.fieldName
        }, [
          (item.sectionName && (index === 0 || _ctx.rows[index - 1].sectionName !== item.sectionName))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["grid-table-row section-header-row", { 'unit-section-header-row': _ctx.isUnitSection(item.sectionName) }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.cells, (cell, cellIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `${item.fieldName}-section-${cell.initials}-${cellIndex}`,
                    class: "section-header-cell"
                  }, [
                    (cellIndex === 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.getSectionHeaderLabel(item.sectionName, index)), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ], 2))
            : _createCommentVNode("", true),
          _createVNode(_component_GridRow, {
            rowData: item,
            rowVisibilityByGroup: _ctx.rowVisibilityByGroup,
            isSubject: _ctx.isSubject,
            class: _normalizeClass({ 'repeatable-group-divider': _ctx.repeatableGroupDividerIndices.has(index) }),
            onToggleRowVisibility: _ctx.toggleRowVisibility
          }, null, 8, ["rowData", "rowVisibilityByGroup", "isSubject", "class", "onToggleRowVisibility"])
        ], 64))
      }), 128))
    ]),
    (_ctx.modalDataPreferenceSettings.show)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalDataPreferenceSettings.component), {
          key: 0,
          defaultTabIdx: _ctx.modalDataPreferenceSettings.defaultTabIdx,
          hiddenTabIdx: _ctx.modalDataPreferenceSettings.hiddenTabIdx,
          fieldId: _ctx.modalDataPreferenceSettings.fieldId,
          onHide: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalDataPreferenceSettings.show = false))
        }, null, 8, ["defaultTabIdx", "hiddenTabIdx", "fieldId"]))
      : _createCommentVNode("", true),
    (_ctx.modalImageViewer.show)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalImageViewer.component), {
          key: 1,
          imagePath: _ctx.modalImageViewer.imagePath,
          onHide: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalImageViewer.show = false))
        }, null, 8, ["imagePath"]))
      : _createCommentVNode("", true)
  ], 64))
}